const PlusIcon = ({ className, props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path d="M7 12L17 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M12 7L12 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}

export default PlusIcon
